import Calendar1 from "@/assets/icons/Calendar1";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import React from "react";

interface NewsCardProps {
  id: number;
  title: string;
  imageUrl: string | StaticImageData;
  category: string;
  date: string; // Optional date prop
}
const NewsCard = ({ title, imageUrl, date, id, category }: NewsCardProps) => {
  return (
    <figure className="relative rounded-md max-w-[26rem] h-64 overflow-hidden w-full group">
      <Image
        src={imageUrl !== "" ? imageUrl : "/assets/images/no-image.png"}
        alt={title}
        width={400}
        height={400}
        className="w-full h-full"
      />
      <Badge className="px-4 py-2 hover:bg-primary-700 rounded-full bg-primary-700 absolute top-3 right-3 sm:-translate-y-14 group-hover:translate-y-0 translate-y-0 transition-all duration-300">
        {category}
      </Badge>
      <div className="absolute bottom-0 left-0 right-0 p-4 text-white bg-gradient-1">
        <figcaption className="sm:group-hover:-translate-y-10 sm:translate-y-0 -translate-y-10 transition-all duration-300">
          <div className="flex items-center gap-1 mb-2">
            <Calendar1 width={23} height={23} />
            <p className="text-sm">{format(date, "dd MMM yyyy")}</p>
          </div>
          <h5 className="md:text-lg text-base font-semibold">{title}</h5>
        </figcaption>
        <Link href={`/news/${id}`}>
          <Button className="rounded-full text-primary-700 hover:text-white bg-white mt-2 absolute sm:translate-y-14 sm:group-hover:-translate-y-10 -translate-y-10">
            Lihat Selengkapnya
          </Button>
        </Link>
      </div>
    </figure>
  );
};

export default NewsCard;
